import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55801656"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fieldWrapper" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "label"
}
const _hoisted_4 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  value: undefined
}
const _hoisted_7 = ["value"]

import { computed, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSelectField',
  props: {
    options: null,
    includedOptions: null,
    excludedOptions: null,
    modelValue: null,
    label: null,
    description: null,
    allowNullSelection: { type: Boolean },
    nullSelectionLabel: null,
    validator: null,
    validationId: null,
    isDisabled: { type: Boolean }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props: any, { emit }) {

const props = __props as {
  options: object,
  includedOptions?: any[],
  excludedOptions?: any[],
  modelValue: any|null,
  label?: string,
  description?: string,
  allowNullSelection?: boolean,
  nullSelectionLabel?: string,
  validator?: (fieldId: any, val: any) => boolean,
  validationId?: string,
  isDisabled?: boolean
}



// Have to bind to the <select> indirectly through this variable, as we can't use it in v-model directly
// Also, the <select> element doesn't let us associate a 'null' value with an <option> - only 'undefined' - so we need to convert between them
const boundValue = ref<any|undefined>(props.modelValue != null ? props.modelValue : undefined);

// Event for two-way binding

watch(boundValue, (val, prevVal) => {
  emit('update:modelValue', val == undefined ? null : val);
  emit('change');
});

watch(()=>props.modelValue, () => {
  boundValue.value = props.modelValue != null ? props.modelValue : undefined;
});

const allowedOptions = computed(() => {
  if (props.includedOptions) {
    return Object.fromEntries(
      Object.entries(props.options).filter(([k,v]) => props.includedOptions!.includes(v))
    );
  } else if (props.excludedOptions) {
    return Object.fromEntries(
      Object.entries(props.options).filter(([k,v]) => !props.excludedOptions!.includes(v))
    );
  } else {
    return props.options;
  }  
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(__props.label), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "top")
    ]),
    (__props.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.description), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("select", {
      class: _normalizeClass(["selectField", { 'is-danger': __props.validator ? !__props.validator(__props.validationId ? __props.validationId : this, __props.modelValue) : false }]),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((boundValue).value = $event)),
      disabled: __props.isDisabled
    }, [
      (__props.allowNullSelection || __props.modelValue == null || __props.modelValue == undefined)
        ? (_openBlock(), _createElementBlock("option", _hoisted_6, _toDisplayString(__props.nullSelectionLabel || 'Select...'), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allowedOptions), (optionValue, optionLabel) => {
        return (_openBlock(), _createElementBlock("option", {
          key: optionValue,
          value: optionValue
        }, _toDisplayString(optionLabel), 9, _hoisted_7))
      }), 128))
    ], 10, _hoisted_5), [
      [_vModelSelect, boundValue.value]
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})